import React, { useContext } from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import BlogBreadcrumbs from './BlogBreadcrumbs';
import {
    KontentRadioMultiChoice,
    KontentStringValue,
} from '../../../types/KontentProps';
import { useIcons } from '../Global/DataUtils/iconQueries';
import { SortedIcons, iconSorter } from '../Global/DataUtils/iconSorter';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';

export interface BlogBreadcrumbsProps {
    blog_home_page: {
        value: {
            elements: {
                slug: KontentStringValue;
                url: string;
                no_follow: KontentRadioMultiChoice<'yes' | 'no'>;
            };
        }[];
    };
    blog_topic: {
        value: {
            codename: string;
            name: string;
        }[];
    };
    headline: KontentStringValue;
    return_home_label: KontentStringValue;
    view_more_copy: KontentStringValue;
}

const BlogBreadcrumbsContainer: React.FC<BlogBreadcrumbsProps> = ({
    ...props
}) => {
    const blogTopic = props.blog_topic?.value[0];

    const setIcon = () => {
        if (!blogTopic) {
            return undefined;
        }

        const icons = useIcons();
        const sortedIcons = iconSorter(icons) as SortedIcons;

        if (
            sortedIcons.byBlogTopic[blogTopic.codename] &&
            sortedIcons.byBlogTopic[blogTopic.codename].dark_gray
        ) {
            return sortedIcons.byBlogTopic[blogTopic.codename].dark_gray[0];
        }

        if (sortedIcons.byBlogTopic[blogTopic.codename]) {
            return sortedIcons.byBlogTopic[blogTopic.codename].all[0];
        }

        return undefined;
    };

    const icon = setIcon();
    const pageMetadata = useContext(PageMetadataContext);

    return (
        <BlogBreadcrumbs
            {...props}
            icon={icon}
            preferredLanguage={pageMetadata.preferredLanguage || 'default'}
        />
    );
};

export default BlogBreadcrumbsContainer;

export const fragmentBlogBreadcrumb = graphql`
    fragment BlogBreadcrumb on kontent_item_component___blog_breadcrumb {
        elements {
            blog_home_page {
                value {
                    ... on kontent_item_layout___master_page {
                        id
                        elements {
                            slug {
                                value
                                url
                            }
                            no_follow {
                                value {
                                    codename
                                }
                            }
                        }
                    }
                }
            }
            blog_topic {
                value {
                    codename
                    name
                }
            }
            headline {
                value
            }
            return_home_label {
                value
            }
            view_more_copy {
                value
            }
        }
    }
`;
